import React from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
//local
import {Tag} from "components/Tag";
import {
  toContractId,
  toRequestId,
  toSignContractId,
  toUploadedContractId,
} from "constants/routes.const";
import {dateTimeFormat} from "helpers/datetime";
import {IconHourglass, IconLock, IconUploadContract, IconFeather} from "components/icons";
import {ProjectLabel} from "components/ProjectLabel";
import {contractType, contractStatus} from "constants/buyer.consts";
import {color} from "constants/color.consts";

const rftStatusIcon = {
  [contractStatus.RFT_PENDING]: <IconHourglass color={color.black} />,
  [contractStatus.RFT_COMPLETED]: <IconLock />,
};

const getIcon = (type, status) => {
  if (type === contractType.RFT) return rftStatusIcon[status];
  if (type === contractType.UPLOADED) return <IconUploadContract color={color.black} />;
  if (type === contractType.HANDYSIGN) return <IconFeather color={color.black} />;
};

export const ContractsTableItem = ({contract}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const {id, type, status, number, name, Supplier, updatedAt, Project, ProjectItem} =
    contract;

  const handleClick = () => {
    if (type === contractType.RFT) {
      const rfpId = ProjectItem?.RequestId;
      if (status === contractStatus.RFT_PENDING) navigate(toRequestId(rfpId));
      if (status === contractStatus.RFT_COMPLETED) navigate(toContractId(rfpId));
    }
    if (type === contractType.RFT_COMPLETED) navigate(toContractId(id));
    if (type === contractType.UPLOADED) navigate(toUploadedContractId(id));
    if (type === contractType.HANDYSIGN) navigate(toSignContractId(id));
  };

  const isSigned = status !== contractStatus.RFT_PENDING;
  const supplierName = Supplier ? Supplier.Company?.companyName ?? Supplier.name : "--";

  return (
    <div
      className={`requests-card_body ${isSigned ? "signed" : "not-signed"}`}
      onClick={handleClick}
    >
      <div className="requests-card_body__icon __wrapper icon-col">
        {getIcon(type, status)}
      </div>
      <div className="requests-card_body__number __wrapper number-col fz-14">
        {number}
      </div>
      <div className="requests-card_body__name __wrapper df-row-center name-col fz-14">
        <Tag
          text={ProjectItem?.account}
          color="black"
          small
          noBackground
          addClass="mr-1"
        />
        <span className="truncate">{t(name || "--")}</span>
      </div>
      <div className="requests-card_body__company __wrapper company-col">
        <span className="truncate">{supplierName || "--"}</span>
      </div>
      <div className="requests-card_body__created __wrapper date-col">
        {dateTimeFormat(updatedAt)}
      </div>
      <div className="requests-card_body__project __wrapper df project-col">
        {Project && <ProjectLabel name={Project.name} code={Project.reference} />}
      </div>
    </div>
  );
};
